var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _g2, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgGoldenVisa = function SvgGoldenVisa(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    ref: ref,
    "aria-labelledby": titleId
  }), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M0.578629 33.0121C1.00117 32.7477 1.41383 32.4709 1.82154 32.1867C1.59421 30.882 1.46572 29.5428 1.44101 28.1788C0.976461 28.5321 0.511912 28.8855 0.0473633 29.2364C0.121493 30.5312 0.28458 31.8013 0.53168 33.0417C0.546506 33.0294 0.561332 33.0195 0.578629 33.0121Z",
    fill: "#EABC3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M53.767 29.3055C54.2612 28.9496 54.753 28.5913 55.2447 28.2331C55.2496 28.0304 55.2521 27.8278 55.2521 27.6252C55.2521 23.852 54.496 20.2567 53.127 16.9801C52.7169 17.2593 52.3067 17.5385 51.8965 17.8178C53.1345 20.862 53.8165 24.1905 53.8165 27.6795C53.8189 28.2256 53.8016 28.7693 53.767 29.3055Z",
    fill: "#EABC3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1598 47.1598C57.9482 36.3714 57.9482 18.8799 47.1598 8.09134C36.3714 -2.69711 18.8797 -2.69711 8.09134 8.09134C-2.69711 18.8799 -2.69711 36.3714 8.09134 47.1598C18.8797 57.9482 36.3714 57.9482 47.1598 47.1598Z",
    fill: "#EABC3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M25.2219 49.4689C28.837 46.8422 32.3928 44.1364 36.0153 41.5196C39.7687 38.8089 43.6111 36.2218 47.4263 33.6025C50.0382 31.8111 52.65 30.0146 55.2471 28.2009C55.252 28.0082 55.2545 27.8179 55.2545 27.6252C55.2545 24.2943 54.6639 21.0993 53.5841 18.1415C52.4202 18.9075 51.2539 19.671 50.0876 20.4321C46.3935 22.8413 42.687 25.2258 38.973 27.6054C35.274 29.9751 31.5724 32.3374 27.8758 34.7071C24.1643 37.0867 20.4603 39.4761 16.7711 41.8903C13.9665 43.7262 11.1693 45.577 8.38696 47.45C11.3448 50.3214 14.945 52.5378 18.9505 53.8598C21.0731 52.4439 23.1562 50.9688 25.2219 49.4689Z",
    fill: "#EABC3C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M9.22447 26.4392C12.4195 23.9706 15.6738 21.5861 18.9603 19.2387C22.3875 16.7924 25.8494 14.393 29.3335 12.0259C32.8127 9.66113 36.3116 7.32603 39.818 5.00082C40.4209 4.60052 41.0238 4.20269 41.6268 3.80238C40.0972 2.90294 38.4762 2.14434 36.7762 1.54883C34.068 3.33042 31.3449 5.09225 28.6392 6.87878C25.0389 9.25589 21.4807 11.6898 17.9669 14.1929C14.468 16.6861 11.0357 19.2733 7.6282 21.8901C5.91827 23.2022 4.22563 24.539 2.50581 25.8387C1.67556 26.4664 0.847769 27.1014 0.00268555 27.7117C0.00762755 29.4686 0.178127 31.1884 0.496886 32.8539C3.51398 30.8722 6.36799 28.6482 9.22447 26.4392Z",
    fill: "#EABC3C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6261 48.7893C39.4622 48.7893 49.0571 39.1944 49.0571 27.3583C49.0571 15.5225 39.4622 5.92737 27.6261 5.92737C15.7899 5.92737 6.19507 15.5225 6.19507 27.3583C6.19507 39.1944 15.7899 48.7893 27.6261 48.7893Z",
    fill: "#CC8832"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4025 42.1498C50.5625 33.9898 50.5615 20.7593 42.4007 12.5986C34.24 4.43779 21.0095 4.437 12.8496 12.5968C4.68975 20.7566 4.69054 33.9873 12.8513 42.1481C21.0122 50.3088 34.2427 50.3095 42.4025 42.1498Z",
    fill: "#EABC3C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6263 1.48944C13.1907 1.48944 1.49048 13.1896 1.49048 27.6252C1.49048 42.0608 13.1931 53.761 27.6263 53.761C42.0619 53.761 53.7621 42.0583 53.7621 27.6252C53.7646 13.1896 42.0619 1.48944 27.6263 1.48944ZM27.6263 49.9655C15.17 49.9655 5.07343 39.869 5.07343 27.4127C5.07343 14.9564 15.17 4.85989 27.6263 4.85989C40.0827 4.85989 50.1792 14.9564 50.1792 27.4127C50.1792 39.869 40.0827 49.9655 27.6263 49.9655Z",
    fill: "#E3A93A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6261 4.45721C14.9128 4.45721 4.6062 14.7662 4.6062 27.4795C4.6062 40.1928 14.9128 50.4994 27.6261 50.4994C40.3394 50.4994 50.6459 40.1928 50.6459 27.4795C50.6459 14.7662 40.3394 4.45721 27.6261 4.45721ZM27.6261 49.9656C15.1697 49.9656 5.07322 39.8691 5.07322 27.4128C5.07322 14.9565 15.1697 4.85999 27.6261 4.85999C40.0824 4.85999 50.1789 14.9565 50.1789 27.4128C50.1789 39.8691 40.0824 49.9656 27.6261 49.9656Z",
    fill: "#E3A93A"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1702 27.7394L51.1677 28.1076L53.4633 28.1221L53.4658 27.754L51.1702 27.7394Z",
    fill: "#EABC3C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1584 28.3319L51.1448 28.6998L53.4386 28.7851L53.4522 28.4172L51.1584 28.3319Z",
    fill: "#EABC3C"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1246 29.0656L51.0996 29.4331L53.3897 29.589L53.4149 29.2215L51.1246 29.0656Z",
    fill: "#EABC3C"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0747 29.7983L51.0383 30.1645L53.3225 30.3913L53.3588 30.0251L51.0747 29.7983Z",
    fill: "#EABC3C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9903 30.5311L50.9426 30.896L53.2187 31.194L53.2664 30.8291L50.9903 30.5311Z",
    fill: "#EABC3C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8901 31.2547L50.8311 31.6182L53.0967 31.9869L53.1558 31.6234L50.8901 31.2547Z",
    fill: "#EABC3C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7699 31.9799L50.6995 32.3414L52.9525 32.781L53.0229 32.4195L50.7699 31.9799Z",
    fill: "#EABC3C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6211 32.7001L50.5393 33.0592L52.7775 33.5692L52.8593 33.2104L50.6211 32.7001Z",
    fill: "#EABC3C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4545 33.418L50.3613 33.774L52.5823 34.3542L52.6754 33.9979L50.4545 33.418Z",
    fill: "#EABC3C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2617 34.126L50.1575 34.4791L52.3591 35.1287L52.4634 34.7756L50.2617 34.126Z",
    fill: "#EABC3C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0485 34.8238L49.9331 35.1734L52.1135 35.892L52.2287 35.5421L50.0485 34.8238Z",
    fill: "#EABC3C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8211 35.5218L49.6948 35.8677L51.8515 36.6545L51.9778 36.3086L49.8211 35.5218Z",
    fill: "#EABC3C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5514 36.2083L49.4146 36.55L51.5453 37.4037L51.6822 37.062L49.5514 36.2083Z",
    fill: "#EABC3C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2786 36.889L49.1311 37.2263L51.2339 38.1468L51.3817 37.8095L49.2786 36.889Z",
    fill: "#EABC3C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9811 37.5564L48.823 37.889L50.8962 38.8749L51.0543 38.5423L48.9811 37.5564Z",
    fill: "#EABC3C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6536 38.2164L48.4851 38.5438L50.5262 39.594L50.6947 39.2666L48.6536 38.2164Z",
    fill: "#EABC3C"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3139 38.8709L48.1353 39.1929L50.1424 40.3066L50.3211 39.9846L48.3139 38.8709Z",
    fill: "#EABC3C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9522 39.5095L47.7634 39.8258L49.735 41.0015L49.9236 40.6852L47.9522 39.5095Z",
    fill: "#EABC3C"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5766 40.1354L47.3782 40.4455L49.3122 41.6825L49.5107 41.3721L47.5766 40.1354Z",
    fill: "#EABC3C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1749 40.7515L46.967 41.0554L48.8616 42.3517L49.0694 42.0478L47.1749 40.7515Z",
    fill: "#EABC3C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7519 41.3571L46.5347 41.6544L48.3879 43.009L48.6051 42.7117L46.7519 41.3571Z",
    fill: "#EABC3C"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3133 41.9412L46.0869 42.2315L47.8972 43.6429L48.1235 43.3526L46.3133 41.9412Z",
    fill: "#EABC3C"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8602 42.5227L45.625 42.8059L47.3905 44.2732L47.6258 43.99L45.8602 42.5227Z",
    fill: "#EABC3C"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3862 43.0833L45.1421 43.359L46.8614 44.8804L47.1053 44.6047L45.3862 43.0833Z",
    fill: "#EABC3C"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8936 43.6294L44.6414 43.8975L46.3125 45.4713L46.5648 45.2034L44.8936 43.6294Z",
    fill: "#EABC3C"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3889 44.1635L44.1282 44.4236L45.7496 46.0483L46.0103 45.7884L44.3889 44.1635Z",
    fill: "#EABC3C"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8611 44.6766L43.5928 44.9287L45.1631 46.603L45.4317 46.351L43.8611 44.6766Z",
    fill: "#EABC3C"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3222 45.1688L43.0461 45.4122L44.5638 47.1343L44.8401 46.8909L43.3222 45.1688Z",
    fill: "#EABC3C"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M42.772 45.6576L42.4883 45.8923L43.9519 47.6608L44.2355 47.4261L42.772 45.6576Z",
    fill: "#EABC3C"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1932 46.1194L41.9026 46.345L43.3103 48.1583L43.6012 47.9324L42.1932 46.1194Z",
    fill: "#EABC3C"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6137 46.5659L41.3159 46.7826L42.6668 48.6386L42.9646 48.4219L41.6137 46.5659Z",
    fill: "#EABC3C"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0198 46.9947L40.7153 47.202L42.0079 49.099L42.3123 48.8917L41.0198 46.9947Z",
    fill: "#EABC3C"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4051 47.3959L40.0947 47.5936L41.3275 49.5301L41.6381 49.3322L40.4051 47.3959Z",
    fill: "#EABC3C"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7848 47.7911L39.4683 47.9791L40.6403 49.953L40.9568 49.7652L39.7848 47.7911Z",
    fill: "#EABC3C"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1501 48.1615L38.8279 48.3394L39.9376 50.3491L40.2598 50.1709L39.1501 48.1615Z",
    fill: "#EABC3C"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5012 48.5104L38.1736 48.6782L39.2196 50.7214L39.5475 50.5536L38.5012 48.5104Z",
    fill: "#EABC3C"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8487 48.8408L37.5159 48.9982L38.4976 51.0734L38.8304 50.9157L37.8487 48.8408Z",
    fill: "#EABC3C"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1796 49.1496L36.842 49.2966L37.758 51.4014L38.0958 51.2544L37.1796 49.1496Z",
    fill: "#EABC3C"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5031 49.4373L36.1609 49.5734L37.0107 51.7061L37.3527 51.5697L36.5031 49.4373Z",
    fill: "#EABC3C"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8223 49.7036L35.4763 49.8291L36.2586 51.9873L36.6046 51.8618L35.8223 49.7036Z",
    fill: "#EABC3C"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M35.126 49.949L34.7761 50.0634L35.49 52.2453L35.8399 52.1306L35.126 49.949Z",
    fill: "#EABC3C"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M34.431 50.1677L34.0776 50.271L34.7226 52.4742L35.0759 52.3706L34.431 50.1677Z",
    fill: "#EABC3C"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7252 50.3817L33.3687 50.4741L33.9442 52.6965L34.3007 52.6041L33.7252 50.3817Z",
    fill: "#EABC3C"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0092 50.5519L32.6499 50.633L33.1552 52.8722L33.5143 52.7912L33.0092 50.5519Z",
    fill: "#EABC3C"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2907 50.7096L31.9292 50.7793L32.3641 53.0333L32.7256 52.9636L32.2907 50.7096Z",
    fill: "#EABC3C"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5669 50.8428L31.2034 50.9011L31.5676 53.1675L31.9311 53.1092L31.5669 50.8428Z",
    fill: "#EABC3C"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8413 50.9507L30.4761 50.9976L30.7691 53.2744L31.1343 53.2275L30.8413 50.9507Z",
    fill: "#EABC3C"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M30.116 51.0424L29.7495 51.0782L29.9717 53.3629L30.3381 53.3274L30.116 51.0424Z",
    fill: "#EABC3C"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3826 51.1035L29.0151 51.1277L29.1664 53.4183L29.5338 53.3941L29.3826 51.1035Z",
    fill: "#EABC3C"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6511 51.147L28.2832 51.1598L28.364 53.4541L28.7319 53.4411L28.6511 51.147Z",
    fill: "#EABC3C"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9153 51.1711L27.5471 51.1729L27.5575 53.4684L27.9257 53.4667L27.9153 51.1711Z",
    fill: "#EABC3C"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8149 51.1534L26.7544 53.4484L27.1223 53.4581L27.1829 51.1633L26.8149 51.1534Z",
    fill: "#EABC3C"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0797 51.1212L25.949 53.4131L26.3164 53.4341L26.4471 51.1422L26.0797 51.1212Z",
    fill: "#EABC3C"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3435 51.0615L25.1418 53.3481L25.5085 53.3805L25.7104 51.0938L25.3435 51.0615Z",
    fill: "#EABC3C"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6126 50.9762L24.3398 53.2554L24.7053 53.2992L24.9781 51.0199L24.6126 50.9762Z",
    fill: "#EABC3C"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8857 50.884L23.5422 53.1536L23.9062 53.2087L24.2499 50.9391L23.8857 50.884Z",
    fill: "#EABC3C"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1612 50.7474L22.7466 53.0052L23.1088 53.0717L23.5232 50.8139L23.1612 50.7474Z",
    fill: "#EABC3C"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4453 50.5994L21.9602 52.843L22.32 52.9209L22.805 50.6772L22.4453 50.5994Z",
    fill: "#EABC3C"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M21.732 50.4274L21.1765 52.6547L21.5338 52.7439L22.0891 50.5163L21.732 50.4274Z",
    fill: "#EABC3C"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0251 50.2282L20.4004 52.4373L20.7547 52.5376L21.3794 50.3285L21.0251 50.2282Z",
    fill: "#EABC3C"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3215 50.015L19.6274 52.2031L19.9783 52.3145L20.6727 50.1265L20.3215 50.015Z",
    fill: "#EABC3C"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6273 49.7797L18.865 51.9451L19.2124 52.0674L19.9745 49.9018L19.6273 49.7797Z",
    fill: "#EABC3C"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9421 49.5193L18.1118 51.6595L18.455 51.7927L19.2853 49.6525L18.9421 49.5193Z",
    fill: "#EABC3C"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2578 49.2413L17.3611 51.3545L17.7001 51.4983L18.5968 49.3851L18.2578 49.2413Z",
    fill: "#EABC3C"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5931 48.9319L16.6304 51.016L16.9645 51.1702L17.9272 49.0864L17.5931 48.9319Z",
    fill: "#EABC3C"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M16.932 48.608L15.905 50.6609L16.2342 50.8258L17.2614 48.7728L16.932 48.608Z",
    fill: "#EABC3C"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2807 48.2685L15.189 50.2878L15.5129 50.4627L16.6046 48.4437L16.2807 48.2685Z",
    fill: "#EABC3C"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6476 47.9035L14.4939 49.888L14.8122 50.073L15.9659 48.0886L15.6476 47.9035Z",
    fill: "#EABC3C"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0221 47.5178L13.8069 49.4654L14.1192 49.6604L15.3345 47.7127L15.0221 47.5178Z",
    fill: "#EABC3C"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4064 47.118L13.1306 49.0266L13.4368 49.2312L14.7123 47.3226L14.4064 47.118Z",
    fill: "#EABC3C"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8056 46.6898L12.4717 48.5578L12.7713 48.7718L14.1053 46.9038L13.8056 46.6898Z",
    fill: "#EABC3C"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2146 46.252L11.8235 48.0778L12.1164 48.3009L13.5074 46.4748L13.2146 46.252Z",
    fill: "#EABC3C"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6419 45.7945L11.1943 47.5761L11.4801 47.8084L12.9277 46.0268L12.6419 45.7945Z",
    fill: "#EABC3C"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0874 45.3162L10.585 47.0518L10.8633 47.2927L12.3658 45.5571L12.0874 45.3162Z",
    fill: "#EABC3C"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5396 44.8258L9.98462 46.5145L10.2555 46.7638L11.8105 45.0751L11.5396 44.8258Z",
    fill: "#EABC3C"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0097 44.3119L9.40308 45.9514L9.66604 46.2091L11.2727 44.5696L11.0097 44.3119Z",
    fill: "#EABC3C"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4987 43.7871L8.8418 45.376L9.09663 45.6416L10.7536 44.0527L10.4987 43.7871Z",
    fill: "#EABC3C"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0025 43.2442L8.29712 44.7809L8.54358 45.0545L10.249 43.5177L10.0025 43.2442Z",
    fill: "#EABC3C"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52585 42.6826L7.77344 44.1652L8.01122 44.4464L9.76366 42.9635L9.52585 42.6826Z",
    fill: "#EABC3C"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06401 42.1146L7.26636 43.5421L7.49532 43.8305L9.29298 42.403L9.06401 42.1146Z",
    fill: "#EABC3C"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61692 41.532L6.77612 42.9035L6.99612 43.1987L8.83691 41.8271L8.61692 41.532Z",
    fill: "#EABC3C"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19437 40.9269L6.31201 42.2407L6.52271 42.5427L8.40508 41.2288L8.19437 40.9269Z",
    fill: "#EABC3C"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M7.78922 40.316L5.86646 41.5698L6.06755 41.8782L7.99033 40.6244L7.78922 40.316Z",
    fill: "#EABC3C"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39521 39.6961L5.43457 40.8901L5.62607 41.2046L7.58672 40.0107L7.39521 39.6961Z",
    fill: "#EABC3C"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03618 39.0538L5.03882 40.1853L5.22026 40.5056L7.21763 39.3743L7.03618 39.0538Z",
    fill: "#EABC3C"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69074 38.4105L4.65894 39.4792L4.83032 39.8051L6.86211 38.7364L6.69074 38.4105Z",
    fill: "#EABC3C"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M6.36081 37.7521L4.29663 38.7566L4.45774 39.0877L6.52192 38.0832L6.36081 37.7521Z",
    fill: "#EABC3C"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05443 37.0822L3.96021 38.0219L4.11094 38.3577L6.20516 37.418L6.05443 37.0822Z",
    fill: "#EABC3C"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76818 36.4081L3.64502 37.2809L3.785 37.6217L5.90816 36.7486L5.76818 36.4081Z",
    fill: "#EABC3C"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50502 35.7225L3.35547 36.528L3.48465 36.8727L5.63423 36.0672L5.50502 35.7225Z",
    fill: "#EABC3C"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M5.26644 35.0291L3.09277 35.7671L3.21118 36.1158L5.38485 35.3775L5.26644 35.0291Z",
    fill: "#EABC3C"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04239 34.3289L2.84668 34.9985L2.95407 35.3506L5.14978 34.681L5.04239 34.3289Z",
    fill: "#EABC3C"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M4.84924 33.6184L2.63379 34.2191L2.73013 34.5744L4.94559 33.9737L4.84924 33.6184Z",
    fill: "#EABC3C"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M4.67597 32.9062L2.44263 33.4368L2.5277 33.7951L4.76104 33.2645L4.67597 32.9062Z",
    fill: "#EABC3C"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51678 32.1901L2.26782 32.6502L2.34166 33.011L4.59062 32.5509L4.51678 32.1901Z",
    fill: "#EABC3C"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M4.39461 31.4672L2.13208 31.8556L2.19442 32.2186L4.45692 31.8299L4.39461 31.4672Z",
    fill: "#EABC3C"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28306 30.7384L2.00977 31.0567L2.06084 31.4214L4.33411 31.1029L4.28306 30.7384Z",
    fill: "#EABC3C"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19535 30.0092L1.91333 30.2571L1.95309 30.623L4.23511 30.3752L4.19535 30.0092Z",
    fill: "#EABC3C"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13852 29.2759L1.84985 29.4523L1.87815 29.8193L4.16682 29.6431L4.13852 29.2759Z",
    fill: "#EABC3C"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M4.0948 28.5425L1.80176 28.6487L1.81876 29.0164L4.1118 28.9104L4.0948 28.5425Z",
    fill: "#EABC3C"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M4.08194 27.8081L1.78662 27.8439L1.79235 28.2121L4.08769 28.1763L4.08194 27.8081Z",
    fill: "#EABC3C"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M1.79277 27.0383L1.78711 27.4065L4.08245 27.4418L4.08808 27.0737L1.79277 27.0383Z",
    fill: "#EABC3C"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M1.817 26.2331L1.80005 26.6008L4.09309 26.7065L4.11004 26.3389L1.817 26.2331Z",
    fill: "#EABC3C"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M1.87744 25.43L1.84912 25.7972L4.13779 25.9736L4.16611 25.6067L1.87744 25.43Z",
    fill: "#EABC3C"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M1.95375 24.6281L1.91406 24.9943L4.19631 25.2417L4.23599 24.8757L1.95375 24.6281Z",
    fill: "#EABC3C"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M2.05984 23.8293L2.00879 24.194L4.28206 24.5125L4.33314 24.1478L2.05984 23.8293Z",
    fill: "#EABC3C"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19184 23.0334L2.12939 23.3964L4.39167 23.7856L4.45411 23.4228L2.19184 23.0334Z",
    fill: "#EABC3C"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33941 22.2409L2.26562 22.6017L4.51458 23.0618L4.58837 22.701L2.33941 22.2409Z",
    fill: "#EABC3C"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M2.52526 21.4563L2.44019 21.8143L4.67353 22.3449L4.75863 21.9866L2.52526 21.4563Z",
    fill: "#EABC3C"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M2.72908 20.6755L2.63281 21.0311L4.84849 21.6313L4.94476 21.276L2.72908 20.6755Z",
    fill: "#EABC3C"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M2.95458 19.9014L2.84717 20.2535L5.04288 20.9231L5.15027 20.571L2.95458 19.9014Z",
    fill: "#EABC3C"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M3.21338 19.1349L3.09497 19.4835L5.26864 20.2219L5.38705 19.8732L3.21338 19.1349Z",
    fill: "#EABC3C"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M3.48597 18.3783L3.35669 18.723L5.50602 19.529L5.63532 19.1843L3.48597 18.3783Z",
    fill: "#EABC3C"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7873 17.6318L3.64722 17.9723L5.77013 18.8458L5.91024 18.5053L3.7873 17.6318Z",
    fill: "#EABC3C"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M4.11382 16.8919L3.96313 17.2277L6.05761 18.1672L6.20829 17.8314L4.11382 16.8919Z",
    fill: "#EABC3C"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45632 16.1625L4.29517 16.4933L6.35912 17.4981L6.52025 17.1672L4.45632 16.1625Z",
    fill: "#EABC3C"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82815 15.4462L4.65674 15.7721L6.68832 16.8408L6.85974 16.5151L4.82815 15.4462Z",
    fill: "#EABC3C"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M5.22158 14.7432L5.04004 15.0634L7.03718 16.1954L7.21872 15.8749L5.22158 14.7432Z",
    fill: "#EABC3C"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62895 14.0488L5.4375 14.3631L7.39836 15.5568L7.58982 15.2423L5.62895 14.0488Z",
    fill: "#EABC3C"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M6.06911 13.3708L5.86792 13.6792L7.79071 14.9335L7.99187 14.6251L6.06911 13.3708Z",
    fill: "#EABC3C"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52391 12.7072L6.31323 13.0091L8.19582 14.3226L8.40649 14.0206L6.52391 12.7072Z",
    fill: "#EABC3C"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99753 12.0525L6.77759 12.3478L8.61863 13.7191L8.83858 13.4238L6.99753 12.0525Z",
    fill: "#EABC3C"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49659 11.4202L7.26758 11.7085L9.06501 13.1363L9.29402 12.848L7.49659 11.4202Z",
    fill: "#EABC3C"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01127 10.801L7.77344 11.0821L9.52563 12.565L9.76349 12.284L8.01127 10.801Z",
    fill: "#EABC3C"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M8.54284 10.1954L8.29639 10.4689L10.0017 12.0055L10.2482 11.732L8.54284 10.1954Z",
    fill: "#EABC3C"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10003 9.61163L8.84521 9.87737L10.5021 11.4661L10.757 11.2004L9.10003 9.61163Z",
    fill: "#EABC3C"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66819 9.04242L9.40527 9.30014L11.0122 10.9394L11.2751 10.6817L9.66819 9.04242Z",
    fill: "#EABC3C"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2566 8.49072L9.98584 8.74017L11.5411 10.4286L11.8119 10.1791L10.2566 8.49072Z",
    fill: "#EABC3C"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8629 7.96027L10.5845 8.20119L12.0867 9.93709L12.3651 9.69617L10.8629 7.96027Z",
    fill: "#EABC3C"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4818 7.44513L11.196 7.6773L12.6436 9.4589L12.9294 9.22672L11.4818 7.44513Z",
    fill: "#EABC3C"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1185 6.95056L11.8257 7.17374L13.2173 8.99942L13.5102 8.77621L12.1185 6.95056Z",
    fill: "#EABC3C"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M12.774 6.47858L12.4744 6.69256L13.8086 8.56069L14.1081 8.3467L12.774 6.47858Z",
    fill: "#EABC3C"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4368 6.02136L13.1306 6.22591L14.4059 8.13466L14.7121 7.93011L13.4368 6.02136Z",
    fill: "#EABC3C"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1195 5.59106L13.8071 5.78598L15.0224 7.73355L15.3347 7.53863L14.1195 5.59106Z",
    fill: "#EABC3C"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8134 5.18201L14.4951 5.36709L15.6491 7.3516L15.9676 7.16652L14.8134 5.18201Z",
    fill: "#EABC3C"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5156 4.78613L15.1919 4.9612L16.2833 6.98061L16.6073 6.80556L15.5156 4.78613Z",
    fill: "#EABC3C"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2349 4.42578L15.9058 4.59057L16.9332 6.64329L17.2626 6.47847L16.2349 4.42578Z",
    fill: "#EABC3C"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9647 4.08105L16.6304 4.23547L17.5931 6.31939L17.9274 6.16497L16.9647 4.08105Z",
    fill: "#EABC3C"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M17.703 3.75195L17.364 3.89579L18.261 6.00887L18.6 5.86501L17.703 3.75195Z",
    fill: "#EABC3C"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4533 3.45978L18.1099 3.59294L18.9404 5.7331L19.2836 5.59994L18.4533 3.45978Z",
    fill: "#EABC3C"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2109 3.18597L18.8638 3.30829L19.6263 5.47346L19.9735 5.35114L19.2109 3.18597Z",
    fill: "#EABC3C"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9788 2.93213L19.6279 3.04347L20.322 5.2316L20.6729 5.12025L19.9788 2.93213Z",
    fill: "#EABC3C"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7525 2.71051L20.3984 2.81073L21.0234 5.01951L21.3774 4.91932L20.7525 2.71051Z",
    fill: "#EABC3C"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5331 2.50348L21.176 2.59253L21.7313 4.81992L22.0886 4.73087L21.5331 2.50348Z",
    fill: "#EABC3C"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3205 2.32788L21.9607 2.40567L22.4458 4.64936L22.8055 4.57158L22.3205 2.32788Z",
    fill: "#EABC3C"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1118 2.18005L22.7498 2.2465L23.1641 4.50443L23.5261 4.43796L23.1118 2.18005Z",
    fill: "#EABC3C"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9079 2.0459L23.5437 2.101L23.8874 4.37064L24.2514 4.31551L23.9079 2.0459Z",
    fill: "#EABC3C"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M24.708 1.94904L24.3425 1.99277L24.6153 4.27205L24.9808 4.22831L24.708 1.94904Z",
    fill: "#EABC3C"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5098 1.87048L25.1431 1.90283L25.3447 4.18945L25.7114 4.15708L25.5098 1.87048Z",
    fill: "#EABC3C"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3154 1.81445L25.948 1.83541L26.0787 4.12731L26.4462 4.10633L26.3154 1.81445Z",
    fill: "#EABC3C"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1204 1.79156L26.7522 1.80125L26.8125 4.09612L27.1807 4.08644L27.1204 1.79156Z",
    fill: "#EABC3C"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5575 1.78198L27.5471 4.07755L27.9153 4.0792L27.9257 1.78364L27.5575 1.78198Z",
    fill: "#EABC3C"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3635 1.79553L28.2827 4.08971L28.6509 4.10266L28.7314 1.80848L28.3635 1.79553Z",
    fill: "#EABC3C"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1661 1.83289L29.0151 4.12338L29.3826 4.1476L29.5336 1.85708L29.1661 1.83289Z",
    fill: "#EABC3C"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9712 1.88757L29.7493 4.17236L30.1157 4.20794L30.3376 1.92318L29.9712 1.88757Z",
    fill: "#EABC3C"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7701 1.97888L30.4773 4.25564L30.8425 4.30261L31.1353 2.02588L30.7701 1.97888Z",
    fill: "#EABC3C"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5713 2.08252L31.2075 4.34917L31.571 4.40754L31.935 2.14088L31.5713 2.08252Z",
    fill: "#EABC3C"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3675 2.21924L31.9326 4.47324L32.2941 4.54302L32.729 2.28899L32.3675 2.21924Z",
    fill: "#EABC3C"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M33.156 2.37988L32.6506 4.6192L33.0099 4.70023L33.515 2.46091L33.156 2.37988Z",
    fill: "#EABC3C"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9427 2.55737L33.3674 4.77972L33.724 4.87199L34.2992 2.64964L33.9427 2.55737Z",
    fill: "#EABC3C"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7213 2.77551L34.0764 4.97856L34.4298 5.082L35.0747 2.87895L34.7213 2.77551Z",
    fill: "#EABC3C"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4934 3.00525L34.7798 5.18719L35.1297 5.30165L35.8433 3.11973L35.4934 3.00525Z",
    fill: "#EABC3C"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2574 3.2594L35.4751 5.41745L35.8213 5.54293L36.6036 3.38488L36.2574 3.2594Z",
    fill: "#EABC3C"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0126 3.54614L36.1631 5.67872L36.5051 5.81499L37.3546 3.68242L37.0126 3.54614Z",
    fill: "#EABC3C"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7617 3.84875L36.8452 5.95358L37.1828 6.10056L38.0992 3.99576L37.7617 3.84875Z",
    fill: "#EABC3C"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4954 4.17468L37.5134 6.24963L37.846 6.40714L38.8282 4.33218L38.4954 4.17468Z",
    fill: "#EABC3C"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2205 4.53003L38.1741 6.57333L38.502 6.74113L39.5482 4.69786L39.2205 4.53003Z",
    fill: "#EABC3C"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9376 4.89948L38.8281 6.90924L39.1503 7.08718L40.2598 5.07744L39.9376 4.89948Z",
    fill: "#EABC3C"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M40.64 5.29816L39.4683 7.27212L39.785 7.46004L40.9565 5.48608L40.64 5.29816Z",
    fill: "#EABC3C"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M41.327 5.71387L40.0945 7.65039L40.4051 7.84812L41.6376 5.91157L41.327 5.71387Z",
    fill: "#EABC3C"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0057 6.15094L40.7129 8.04776L41.0171 8.25512L42.3099 6.35831L42.0057 6.15094Z",
    fill: "#EABC3C"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6666 6.6134L41.3157 8.46937L41.6132 8.68606L42.9643 6.83009L42.6666 6.6134Z",
    fill: "#EABC3C"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3154 7.09424L41.9075 8.90729L42.1981 9.13311L43.6063 7.32009L43.3154 7.09424Z",
    fill: "#EABC3C"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9514 7.59015L42.4871 9.3582L42.7707 9.59302L44.2348 7.82497L43.9514 7.59015Z",
    fill: "#EABC3C"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5641 8.11279L43.0461 9.83469L43.3224 10.0782L44.8403 8.35626L44.5641 8.11279Z",
    fill: "#EABC3C"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1638 8.65143L43.593 10.3253L43.8614 10.5773L45.4322 8.90337L45.1638 8.65143Z",
    fill: "#EABC3C"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7509 9.20349L44.1292 10.8281L44.3896 11.0882L46.0116 9.46361L45.7509 9.20349Z",
    fill: "#EABC3C"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3074 9.78107L44.6365 11.3549L44.889 11.6229L46.5599 10.0491L46.3074 9.78107Z",
    fill: "#EABC3C"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8592 10.368L45.1401 11.8892L45.384 12.165L47.1031 10.6437L46.8592 10.368Z",
    fill: "#EABC3C"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3942 10.9762L45.6287 12.4435L45.8639 12.7267L47.6294 11.2594L47.3942 10.9762Z",
    fill: "#EABC3C"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8989 11.6016L46.0889 13.0135L46.3155 13.3038L48.1255 11.8919L47.8989 11.6016Z",
    fill: "#EABC3C"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3887 12.2418L46.5352 13.5962L46.7524 13.8934L48.6059 12.5391L48.3887 12.2418Z",
    fill: "#EABC3C"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8635 12.8967L46.9688 14.1926L47.1766 14.4966L49.0713 13.2006L48.8635 12.8967Z",
    fill: "#EABC3C"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3069 13.565L47.3733 14.8025L47.5717 15.1126L49.5053 13.8754L49.3069 13.565Z",
    fill: "#EABC3C"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7394 14.248L47.7678 15.4242L47.9566 15.7405L49.928 14.564L49.7394 14.248Z",
    fill: "#EABC3C"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1427 14.9451L48.1355 16.0585L48.3142 16.3805L50.3213 15.2668L50.1427 14.9451Z",
    fill: "#EABC3C"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5306 15.6537L48.4893 16.7041L48.6578 17.0315L50.6991 15.9811L50.5306 15.6537Z",
    fill: "#EABC3C"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8962 16.3705L48.8232 17.357L48.9814 17.6896L51.0543 16.7031L50.8962 16.3705Z",
    fill: "#EABC3C"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2359 17.1051L49.1328 18.0258L49.2806 18.3631L51.3834 17.4424L51.2359 17.1051Z",
    fill: "#EABC3C"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5473 17.8497L49.4163 18.7032L49.5532 19.0449L51.6841 18.1914L51.5473 17.8497Z",
    fill: "#EABC3C"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8464 18.5942L49.6897 19.3804L49.816 19.7264L51.9727 18.9401L51.8464 18.5942Z",
    fill: "#EABC3C"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1113 19.3569L49.9312 20.0755L50.0463 20.4251L52.2265 19.7066L52.1113 19.3569Z",
    fill: "#EABC3C"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3567 20.121L50.1553 20.7714L50.2595 21.1245L52.461 20.4741L52.3567 20.121Z",
    fill: "#EABC3C"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M52.585 20.9024L50.3638 21.4823L50.4567 21.8384L52.6779 21.2587L52.585 20.9024Z",
    fill: "#EABC3C"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7729 21.6854L50.5347 22.1952L50.6165 22.554L52.8544 22.0445L52.7729 21.6854Z",
    fill: "#EABC3C"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9508 22.4702L50.6978 22.9096L50.7682 23.2708L53.0212 22.8315L52.9508 22.4702Z",
    fill: "#EABC3C"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0977 23.2639L50.8318 23.6331L50.8911 23.9966L53.1568 23.6274L53.0977 23.2639Z",
    fill: "#EABC3C"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2218 24.0598L50.9456 24.3573L50.9932 24.7223L53.2695 24.4248L53.2218 24.0598Z",
    fill: "#EABC3C"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M53.323 24.8589L51.0388 25.0858L51.0751 25.4522L53.3596 25.2251L53.323 24.8589Z",
    fill: "#EABC3C"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M53.388 25.6625L51.0977 25.818L51.1226 26.1852L53.413 26.03L53.388 25.6625Z",
    fill: "#EABC3C"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4376 26.4656L51.1436 26.5509L51.1574 26.9188L53.4512 26.8336L53.4376 26.4656Z",
    fill: "#EABC3C"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4655 27.1439L51.1699 27.1589L51.1724 27.5271L53.468 27.512L53.4655 27.1439Z",
    fill: "#EABC3C"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M42.0665 4.06919C40.4727 3.09067 38.7752 2.2703 36.9886 1.62537C36.4821 1.97625 35.9755 2.3296 35.4714 2.68543C37.3197 3.26364 39.0791 4.04448 40.7248 4.99582C41.172 4.68941 41.6193 4.38054 42.0665 4.06919Z",
    fill: "#EABC3C"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M21.2732 53.0963C16.7439 51.9671 12.6791 49.6592 9.42722 46.5161C9.04668 46.7953 8.66615 47.0745 8.28809 47.3537C11.4979 50.4993 15.4713 52.869 19.9067 54.1589C20.3614 53.803 20.8161 53.4497 21.2732 53.0963Z",
    fill: "#EABC3C"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M47.5349 33.7385C48.1749 31.732 48.5233 29.5921 48.5233 27.3732C48.5233 25.0677 48.1502 22.8512 47.4608 20.7781C44.5376 22.7005 17.8335 40.4226 13.9836 43.2024C17.6432 46.3579 22.4073 48.268 27.6186 48.2705C30.5468 46.0713 43.4825 37.1435 47.5349 33.7385Z",
    fill: "#EABC3C"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M9.11819 26.9284C12.9482 24.1115 16.7585 21.2649 20.6528 18.5369C24.3865 15.9226 28.1845 13.3972 31.9824 10.8744C33.3143 9.98974 34.6461 9.10265 35.9755 8.21309C34.1124 7.40013 32.1059 6.85156 30.0081 6.61188C28.864 7.44461 27.7224 8.2798 26.5783 9.11253C22.6914 11.9418 18.8169 14.7884 14.9819 17.6844C12.3058 19.7082 9.66922 21.7789 7.02772 23.8446C6.83251 24.9912 6.7312 26.1698 6.7312 27.3708C6.7312 27.7982 6.74356 28.2232 6.77074 28.6458C7.55404 28.0775 8.33735 27.5017 9.11819 26.9284Z",
    fill: "#EABC3C"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73128 27.1805C6.69916 15.7299 16.2867 6.27338 27.7249 6.39446C39.1286 6.34998 48.6865 15.9671 48.5234 27.3782C48.5036 24.6551 47.96 21.9321 46.9049 19.4215C43.144 10.3357 33.3218 5.05024 23.675 6.94797C14.0356 8.74933 6.82024 17.3756 6.73128 27.1805Z",
    fill: "#FFF7A3"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4188 27.3855C1.37926 13.0266 13.4056 1.16331 27.7498 1.31404C42.0545 1.25968 54.0413 13.3206 53.8337 27.6302C53.809 24.2128 53.127 20.8003 51.8026 17.6498C47.0904 6.26099 34.7699 -0.368711 22.6694 2.01334C10.5813 4.27183 1.53246 15.0898 1.4188 27.3855Z",
    fill: "#FFF7A3"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3602 25.9385C11.4278 25.9385 10.6449 25.6449 10.0117 25.0577C9.38429 24.4646 9.07056 23.7107 9.07056 22.7955C9.07056 21.8743 9.38718 21.1203 10.0204 20.5332C10.6478 19.946 11.448 19.6525 12.4207 19.6525C13.0483 19.6525 13.6355 19.7963 14.1821 20.0842V21.5434C13.6239 21.2383 13.0742 21.0858 12.5329 21.0858C11.9862 21.0858 11.5372 21.2469 11.186 21.5693C10.8407 21.8915 10.668 22.309 10.668 22.8214C10.668 23.3567 10.832 23.7798 11.1601 24.0907C11.4882 24.4015 11.8883 24.5569 12.3602 24.5569C12.7634 24.5569 13.0828 24.4619 13.3187 24.272V22.2947H14.8815V24.98C14.6398 25.2447 14.2917 25.4722 13.8368 25.6621C13.3705 25.8462 12.8783 25.9385 12.3602 25.9385ZM17.7026 24.0216C18.0075 24.3438 18.3875 24.5051 18.8424 24.5051C19.2914 24.5051 19.6683 24.3438 19.9735 24.0216C20.2784 23.6991 20.4312 23.2903 20.4312 22.7955C20.4312 22.3003 20.2784 21.8915 19.9735 21.5693C19.6683 21.2469 19.2914 21.0858 18.8424 21.0858C18.3875 21.0858 18.0075 21.2469 17.7026 21.5693C17.4031 21.8859 17.2536 22.2947 17.2536 22.7955C17.2536 23.2963 17.4031 23.7048 17.7026 24.0216ZM21.1219 25.0232C20.5175 25.6333 19.7577 25.9385 18.8424 25.9385C17.9271 25.9385 17.1673 25.6333 16.5629 25.0232C15.9584 24.4128 15.6562 23.6703 15.6562 22.7955C15.6562 21.9204 15.9584 21.1778 16.5629 20.5677C17.1673 19.9574 17.9271 19.6525 18.8424 19.6525C19.7577 19.6525 20.5175 19.9574 21.1219 20.5677C21.7263 21.1778 22.0286 21.9204 22.0286 22.7955C22.0286 23.6703 21.7263 24.4128 21.1219 25.0232ZM27.4522 25.8176H22.9967V19.7733H24.5509V24.4533H27.4522V25.8176ZM30.6675 25.8176H28.2584V19.7733H30.6675C31.6459 19.7733 32.4489 20.0553 33.0765 20.6195C33.6982 21.1835 34.0091 21.9088 34.0091 22.7955C34.0091 23.6935 33.6982 24.4215 33.0765 24.98C32.4605 25.5383 31.6575 25.8176 30.6675 25.8176ZM29.8127 21.1376V24.4533H30.5552C31.1424 24.4533 31.597 24.3092 31.9195 24.0216C32.2417 23.7337 32.403 23.3249 32.403 22.7955C32.403 22.2658 32.2417 21.857 31.9195 21.5693C31.597 21.2814 31.1424 21.1376 30.5552 21.1376H29.8127ZM39.6415 25.8176H34.9788V19.7733H39.5725V21.1376H36.5331V21.9579H38.9508V23.2704H36.5331V24.4533H39.6415V25.8176ZM42.0471 25.8176H40.5188V19.7733H41.8485L44.4907 23.0977V19.7733H46.0104V25.8176H44.7238L42.0471 22.476V25.8176ZM20.8602 36.1057H19.3837L16.9142 30.0269H18.6325L20.1349 33.9643L21.6459 30.0269H23.3383L20.8602 36.1057ZM25.5973 36.0712H24.0431V30.0269H25.5973V36.0712ZM28.9238 36.192C27.9913 36.192 27.2115 35.9762 26.5839 35.5445V33.9557C26.8256 34.1802 27.171 34.3758 27.62 34.5428C28.0517 34.7039 28.4662 34.7846 28.8634 34.7846C29.4794 34.7846 29.7873 34.6262 29.7873 34.3097C29.7873 34.1829 29.7096 34.065 29.5542 33.9557C29.5196 33.9268 29.3901 33.875 29.1656 33.8003L28.6216 33.6362L28.1813 33.5067L27.7841 33.3513C27.6057 33.2822 27.4732 33.2188 27.3869 33.1613C27.076 32.9309 26.8804 32.7468 26.7997 32.6087C26.6559 32.3324 26.5839 32.0358 26.5839 31.7193C26.5839 31.1435 26.7941 30.6975 27.2142 30.381C27.6402 30.0642 28.2217 29.9061 28.9584 29.9061C29.6953 29.9061 30.3774 30.0728 31.0048 30.4069V31.9007C30.7344 31.7336 30.4149 31.5955 30.0463 31.4862C29.6664 31.371 29.3097 31.3135 28.9756 31.3135C28.4462 31.3135 28.1813 31.4457 28.1813 31.7107C28.1813 31.8256 28.2649 31.9179 28.4317 31.987L28.708 32.082C28.7714 32.1049 28.9066 32.1451 29.1138 32.2029C29.321 32.2603 29.4621 32.3005 29.5369 32.3237C30.1127 32.5137 30.5674 32.7525 30.9012 33.0404C31.2293 33.3224 31.3933 33.7253 31.3933 34.2493C31.3933 34.8364 31.1632 35.3084 30.7026 35.6653C30.2479 36.0164 29.6551 36.192 28.9238 36.192ZM33.4289 36.0712H31.7884L34.3269 29.9924H35.8207L38.3593 36.0712H36.6928L36.1834 34.7932H33.9384L33.4289 36.0712ZM35.0609 31.9352L34.4305 33.5499H35.6912L35.0609 31.9352Z",
    fill: "#57430D"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGoldenVisa);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;